import axios from "axios";

function ajaxAction(endpoint, callback, args, postData) {
    console.log('ajaxAction', endpoint, args, postData);
    const method = (postData !== undefined)?'post':'get';

    axios[method]('/'+endpoint, postData)
        .then(function (response) {
            // console.log(response);
            switch (response.data.status) {
                case 'OK':
                    callback({data:(response.data.data ? response.data.data : true), args:args}); //if no data, then just return true, so that we know it was successful
                    break;
                case 'ERROR':
                    callback({data:false, args:args, errors:(response.data.data ? response.data.data : 'ERROR')}); //if no data, then just return 'ERROR'
                    break;
                default:
                    break;
            }
        })
        .catch(function (error) {
            callback({data:false, args:args, errors:error});
        })
        .then(() => {

        })
    ;
}

export {ajaxAction}
